module.exports = __webpack_public_path__ + "img/stats.6e762112.svg";